import {
  useSetting,
  useAssignSetting,
} from "@faire/deprecated-retailer-visitor-shared/settings/__internal__/useSetting";
import { CART_BUILDING_AND_SAVINGS_GUIDE_POST_FCO_250605 } from "@faire/web-api--source/indigofair/settings/CART_BUILDING_AND_SAVINGS_GUIDE_POST_FCO_250605";
import { CART_BUILDING_AND_SAVINGS_GUIDE_PRE_FCO_250605 } from "@faire/web-api--source/indigofair/settings/CART_BUILDING_AND_SAVINGS_GUIDE_PRE_FCO_250605";

import { useRetailer } from "../hooks/retailer/useRetailer";

const useSettingCartBuildingAndSavingsGuidePreFco = (): boolean =>
  useSetting(CART_BUILDING_AND_SAVINGS_GUIDE_PRE_FCO_250605, false);

const useSettingCartBuildingAndSavingsGuidePostFco = (): boolean =>
  useSetting(CART_BUILDING_AND_SAVINGS_GUIDE_POST_FCO_250605, false);

const useAssignSettingCartBuildingAndSavingsGuidePreFco = () =>
  useAssignSetting(CART_BUILDING_AND_SAVINGS_GUIDE_PRE_FCO_250605);

const useAssignSettingCartBuildingAndSavingsGuidePostFco = () =>
  useAssignSetting(CART_BUILDING_AND_SAVINGS_GUIDE_POST_FCO_250605);

export const useSettingCartBuildingAndSavingsGuide = (): boolean => {
  const { retailer } = useRetailer();
  const preFcoSetting = useSettingCartBuildingAndSavingsGuidePreFco();
  const postFcoSetting = useSettingCartBuildingAndSavingsGuidePostFco();

  return retailer?.first_confirmed_order_at ? postFcoSetting : preFcoSetting;
};

export const useAssignSettingCartBuildingAndSavingsGuide = () => {
  const { retailer } = useRetailer();
  const assignPreFcoSetting =
    useAssignSettingCartBuildingAndSavingsGuidePreFco();
  const assignPostFcoSetting =
    useAssignSettingCartBuildingAndSavingsGuidePostFco();

  return retailer?.first_confirmed_order_at
    ? assignPostFcoSetting
    : assignPreFcoSetting;
};
